import { Button, Dialog } from '@noorden-insurtech/alba-design-system';
import { CircleCheck } from 'lucide-react';

type Props = {
  isOpen: boolean;
  isLoading: boolean;
  isBusinessProposal?: boolean;
  requiresInspection?: string;
  onConfirm: () => void;
  onClose: () => void;
};

function getConfirmDescription(
  isBusinessProposal: boolean,
  goesToInspection: boolean
): string {
  if (isBusinessProposal) {
    return 'Ao confirmar, esta proposta será encaminhada para análise de subscrição. Você poderá acompanhar o andamento na listagem de propostas.';
  }

  if (goesToInspection) {
    return 'Ao confirmar, esta proposta será encaminhada para inspeção e ficará aguardando a análise da subscrição antes da emissão.';
  }

  return 'Ao confirmar, esta proposta será transmitida e enviada diretamente para o processo de emissão da apólice.';
}

export function ModalConfirmTransmit({
  isOpen,
  isLoading,
  isBusinessProposal = false,
  requiresInspection,
  onConfirm,
  onClose,
}: Props) {
  const goesToInspection = requiresInspection === 'S';
  const description = getConfirmDescription(
    isBusinessProposal,
    goesToInspection
  );

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='max-w-md'>
          <Dialog.Header>
            <Dialog.Title className='flex items-center gap-2'>
              <CircleCheck
                className='w-5 h-5 text-alba-blue-500'
                strokeWidth={1.6}
              />
              Confirmar transmissão
            </Dialog.Title>
          </Dialog.Header>
          <Dialog.Body className='space-y-2'>
            <p className='text-alba-gray-700 text-sm leading-relaxed'>
              {description}
            </p>
            <p className='text-alba-gray-700 text-sm leading-relaxed'>
              Esta ação não poderá ser desfeita.
            </p>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <Button variant='ghost' size='md' disabled={isLoading}>
                Cancelar
              </Button>
            </Dialog.CloseTrigger>
            <Button
              variant='primary'
              size='md'
              loading={isLoading}
              disabled={isLoading}
              onClick={onConfirm}
            >
              Confirmar Transmissão
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
